import React from 'react';
import classes from '../sourceSetup.module.scss';
import { Body, H3 } from '@ui-library/typography';
import { Flex } from '@ui-library/misc';
import Button from '@ui-library/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import WriteKeyContainer from '../writeKey';
import { ISetupProps } from '../sdkSetup';
import InvitTeamMembers from '../inviteTeamMembers';
import { InfoMessage, LineBreaker } from '../styles';

const NonSdkSetup = ({ source, goToGuide, goToTeammates }: ISetupProps) => (
  <div className={classes.nonSdkSource}>
    <H3>{source?.sourceDef?.displayName} setup overview</H3>
    <Flex className={classes.guidelineContainer}>
      <div className={classes.writeKey}>
        <Body>Setup guide</Body>
        <InfoMessage>Follow the setup guide to get started</InfoMessage>
      </div>
      <Flex alignItems="center">
        <Button onClick={goToGuide}>
          See setup guide
          <FontAwesomeIcon
            className={classes.arrowIcon}
            icon={regular('arrow-up-right-from-square')}
          />
        </Button>
      </Flex>
    </Flex>
    <LineBreaker />
    <WriteKeyContainer writeKey={source.writeKey} />
    <Flex className={classes.nonSdkTeammembers} justifyContent="flex-end">
      <InvitTeamMembers goToTeammates={goToTeammates} />
    </Flex>
  </div>
);

export default NonSdkSetup;
